import { createFileRoute } from '@tanstack/react-router'

import { InsightsSearchSchema } from '@/pages/brevo/insights/insights-search'

export const Route = createFileRoute('/_layout/brevo/insights')({
  validateSearch: InsightsSearchSchema,
})
